<template>
    <v-container fluid class="scroll-y fullscreen accent" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    to="/newjob"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="jobs-count" >
                     {{ total + ' Jobs Found.' }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card>
        <v-card
            flat
            tile
            min-width="100%"
        >
            <v-row class="fill-height">
                <v-col class="pt-0 pb-0">
                    <v-text-field
                        label="Search By Customer/Address/Job #"
                        filled
                        v-model="filter.keyword"
                        @keydown.enter="getJobs"
                        dark
                        hide-details
                        background-color="#04b9e4"
                        append-icon="mdi-magnify"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-card>
        <v-card
            flat
            loader-height="10"
            tile
            min-width="100%"
            class="mt-3"
        >
            <v-list two-line tile flat class="py-0 hover-list primary">
                <v-list-item-group>
                    <template v-for="(job, index) in jobs">
                        <v-list-item
                        :key="`job-${index}`"
                        :value="job.id"                 
                        >
                            <template>
                                <v-list-item-content @click.stop="openJob(job.id)">
                                    <v-list-item-title v-html="'Job# ' + job.job_no + ' - ' + job.customer.first_name + ' ' + job.customer.last_name" class="white--text"></v-list-item-title>
                                    <v-list-item-subtitle class="white--text">{{ job.customer.street_address+ ', ' + job.customer.city + ', ' + job.customer.state + ' ' + job.customer.zip }}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="white--text">Created {{ job.created_at | moment("from", "now") }}</v-list-item-subtitle>
                                    <div>
                                        <v-chip
                                        class="mr-2 mb-1"
                                        :color="getColor(job.status)"
                                        text-color="white"
                                        small
                                        label
                                        >
                                        {{ job.status | capitalize }}
                                        </v-chip>
                                    </div>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-list-item-icon class="ma-0 mb-1">
                                        <v-btn small tile class="mr-1" elevation="0" color="light-blue" dark @click.stop="googleLink(job.customer)">
                                            <v-icon dark>mdi-map-marker</v-icon>
                                        </v-btn>

                                        <v-btn small tile class="mr-1" color="accent" elevation="0" dark @click.stop="dial(job.customer.phone)">
                                            <v-icon dark>mdi-phone</v-icon>
                                        </v-btn>
                                    </v-list-item-icon>
                                </v-list-item-action>
                            </template>
                        </v-list-item>
                        <v-divider
                        :key="`dv-${index}`"
                        ></v-divider>
                    </template>
                </v-list-item-group>  
                <v-list-item v-if="pagination.total > 1" class="accent">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                            dark
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            today: new Date().toISOString().substr(0, 10),
            focus: new Date().toISOString().substr(0, 10),
            type: 'month',
            typeToLabel: {
                month: 'Month',
                week: 'Week',
                day: 'Day',
                '4day': '4 Days',
            },
            name: null,
            details: null,
            start: null,
            end: null,
            color: '#1976D2', // default event color
            currentlyEditing: null,
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            dialog: false,
            dialogDate: false,
            showmap: true,
            drawer: false,
            loading: true,
            downloadLoading: false,
            jobs: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                job_no: "",
                keyword: "",
                status: ["active", "completed"],
                foreman: "all"
            },
            total: 0,
            markers: [],
            mapKey: 0,
            json_fields: {
                'Date': 'date',
                'Customer Name': 'customer_name',
                'Address': 'address',
                'Chemicals': 'chemicals',
            },
        }
    },
    watch: {
        filter: {
            deep: true,

            handler(newValue) {
                this.$store.commit('SET_JOBS_FILTER', newValue)
            }
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        if(this.$store.state.filter.jobs) {
            this.filter = this.$store.state.filter.jobs
        }
        if(this.jobs.length == 0) {
            this.jobs = this.vjobs

            if(this.jobs.length == 0) {
                this.getJobs()
            }
        } else {
            this.getJobs()
        }
    },
    computed: {
        ...mapGetters({
            vjobs: 'data/jobs',
        }),
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else if(this.filter.status != 'all' && this.filter.cleaner != []) {
                //return this.filter.status.charAt(0).toUpperCase() + this.filter.status.slice(1) + ' Jobs'
                return this.pageTitle
            } else {
                return this.pageTitle
            }
        },
        ctitle () {
            const { start, end } = this
            if (!start || !end) {
                return ''
            }
            const startMonth = this.monthFormatter(start)
            const endMonth = this.monthFormatter(end)
            const suffixMonth = startMonth === endMonth ? '' : endMonth
            const startYear = start.year
            const endYear = end.year
            const suffixYear = startYear === endYear ? '' : endYear
            const startDay = start.day + this.nth(start.day)
            const endDay = end.day + this.nth(end.day)
            switch (this.type) {
                case 'month':
                return `${startMonth} ${startYear}`
                case 'week':
                case '4day':
                return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
                case 'day':
                return `${startMonth} ${startDay} ${startYear}`
            }
            return ''
        },
        monthFormatter () {
            return this.$refs.calendar.getFormatter({
                timeZone: 'UTC', month: 'long',
            })
        },
    },
    methods: {
        getJobs() {
            this.loading = true
            this.drawer = false
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.$store.commit('data/SET_JOBS', response.data.jobs.data)
                this.jobs = response.data.jobs.data
                this.markers = response.data.markers
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.all = response.data.all
                this.events = response.data.calendar
                this.mapKey += 1
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getJobs()
            this.$vuetify.goTo(0)
        },
        openJob(id) {
            this.$router.push({ path: '/job/main/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        googleLink (customer) {
            let link = 'https://www.google.com/maps?saddr=Current+Location&daddr=' + encodeURI(customer.street_address+ ', ' + customer.city + ', ' + customer.state + ' ' + customer.zip)
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateJobNo(val) {
            this.filter.job_no = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updateStatus(val) {
            this.filter.status = val
            this.getJobs()
        },
        updateForeman(val) {
            this.filter.foreman = val
            this.getJobs()
        },
        submitSearch() {
            this.getJobs()
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
        setDialogDate( { date }) {
            this.dialogDate = true
            this.focus = date
        },
        viewDay ({ date }) {
            this.focus = date
            this.type = 'day'
        },
        getEventColor (event) {
            return event.color
        },
        showEvent ({ nativeEvent, event }) {
            this.$router.push('/job/main/' + event.id)
            nativeEvent.stopPropagation()
        },
        setToday () {
            this.focus = this.today
        },
        prev () {
            this.$refs.calendar.prev()
        },
        next () {
            this.$refs.calendar.next()
        },
        updateRange ({ start, end }) {
            this.start = start
            this.end = end
        },
        nth (d) {
            return d > 3 && d < 21
            ? 'th'
            : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff
.fullscreen
    background: #fff
    height: 100%
.w-100
    width: 100%
    .v-btn 
        width: 100%
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.v-chip 
    border-radius: 0!important
.jobs-count
    font-size: 14px
.jg-header
    background: #1976d2
    color: #fff
    font-size: 18px
</style>